var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSettingsTune = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings - tune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.29175 9.99996H11.0417M11.0417 9.99996C11.0417 10.5525 11.2612 11.0824 11.6519 11.4731C12.0426 11.8638 12.5725 12.0833 13.1251 12.0833C13.6776 12.0833 14.2075 11.8638 14.5982 11.4731C14.9889 11.0824 15.2084 10.5525 15.2084 9.99996M11.0417 9.99996C11.0417 9.44743 11.2612 8.91752 11.6519 8.52682C12.0426 8.13612 12.5725 7.91663 13.1251 7.91663C13.6776 7.91663 14.2075 8.13612 14.5982 8.52682C14.9889 8.91752 15.2084 9.44743 15.2084 9.99996M15.2084 9.99996H17.7084M6.45841 4.37496H17.7084M6.45841 4.37496C6.45841 4.92749 6.23892 5.4574 5.84822 5.8481C5.45752 6.2388 4.92762 6.45829 4.37508 6.45829C3.82255 6.45829 3.29264 6.2388 2.90194 5.8481C2.51124 5.4574 2.29175 4.92749 2.29175 4.37496C2.29175 3.82243 2.51124 3.29252 2.90194 2.90182C3.29264 2.51112 3.82255 2.29163 4.37508 2.29163C4.92762 2.29163 5.45752 2.51112 5.84822 2.90182C6.23892 3.29252 6.45841 3.82243 6.45841 4.37496ZM2.29175 15.625H4.79175M4.79175 15.625C4.79175 16.1775 5.01124 16.7074 5.40194 17.0981C5.79264 17.4888 6.32255 17.7083 6.87508 17.7083C7.42762 17.7083 7.95752 17.4888 8.34822 17.0981C8.73892 16.7074 8.95842 16.1775 8.95842 15.625M4.79175 15.625C4.79175 15.0724 5.01124 14.5425 5.40194 14.1518C5.79264 13.7611 6.32255 13.5416 6.87508 13.5416C7.42762 13.5416 7.95752 13.7611 8.34822 14.1518C8.73892 14.5425 8.95842 15.0724 8.95842 15.625M8.95842 15.625H17.7084",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsTune, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings-tune.30097122.svg";
export { ForwardRef as ReactComponent };